import { render } from "./NotificationResponseCounterAndReminder.vue?vue&type=template&id=133cfa9e&scoped=true&ts=true"
import script from "./NotificationResponseCounterAndReminder.vue?vue&type=script&lang=ts"
export * from "./NotificationResponseCounterAndReminder.vue?vue&type=script&lang=ts"

import "./NotificationResponseCounterAndReminder.vue?vue&type=style&index=0&id=133cfa9e&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133cfa9e"]])

export default __exports__